/* eslint-disable max-len */
import {
  Component,
  ComponentInterface,
  Prop,
  h,
  Host,
  Element,
} from '@stencil/core';
import { versionComponent } from '../../global/inject-dependencies';

/**
 * A leadtext is a component used for text that should be highlighted and a focal point of the page.
 */
@Component({
  tag: 'ui-leadtext',
  styleUrl: 'ui-leadtext.scss',
  shadow: false,
})
export class UiLeadtext implements ComponentInterface {
  @Element() el: HTMLElement;

  /**
   * Changes the text's font color to *white*.
   */
  @Prop({ reflect: true }) variant: 'white';

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}

versionComponent(UiLeadtext);
